module.exports = __webpack_public_path__ + "img/featuredartist (2).1cc8512a.jpg";